module.exports = __webpack_public_path__ + "img/3.8bd3ab0d.jpg";